define('bootstraps/creatives',[
    'common/modules/commercial/creatives/branded-component',
    'common/modules/commercial/creatives/commercial-component',
    'common/modules/commercial/creatives/expandable',
    'common/modules/commercial/creatives/expandable-v2',
    'common/modules/commercial/creatives/expandable-v3',
    'common/modules/commercial/creatives/fluid250',
    'common/modules/commercial/creatives/fluid250-v3',
    'common/modules/commercial/creatives/fluid250GoogleAndroid',
    'common/modules/commercial/creatives/foundation-funded-logo',
    'common/modules/commercial/creatives/scrollable-mpu',
    'common/modules/commercial/creatives/scrollable-mpu-v2',
    'common/modules/commercial/creatives/template'
], function () {});

